import React, { useEffect, useState } from 'react';
import { IOrderExclusion } from '../../models/OrderExclusions.model';
import {
  Grid,
  GridColumn,
  GridColumnMenuFilter,
} from '@progress/kendo-react-grid';
import CommandCell from '../userAdmin/CommandCell';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { process } from '@progress/kendo-data-query';
import ColumnMenu from '../shared/ColumnMenu';
import { locale } from '../../common/localization/localizationService';

export interface IOrderExclusionsGridProps {
  data: Array<IOrderExclusion>;
  className?: string;
  editExclusion: (dataItem: IOrderExclusion) => void;
  deleteExclusion: (dataItem: IOrderExclusion) => void;
}

export default function OrderExclusionsGrid(
  props: IOrderExclusionsGridProps
): JSX.Element {
  const [dataState, setDataState] = useState({
    sort: [{ dir: 'asc', field: 'date' }],
    take: 26,
    skip: 0,
  });

  const dataStateChange = (event: any) => {
    setDataState(event.data);
  };

  const columnProps = (field: string) => {
    return {
      field: field,
      columnMenu: ColumnMenu,
      headerClassName: isColumnActive(field, dataState) ? 'active' : '',
    };
  };

  const isColumnActive = (field: string, dataState: any) => {
    return GridColumnMenuFilter.active(field, dataState.filter);
  };

  const UpdateExclusionCell = (columnProps: any) => {
    return (
      <>
        <CommandCell
          {...columnProps}
          edit={props.editExclusion}
          icon={faEdit}
        />
      </>
    );
  };

  const DeleteExclusionCell = (columnProps: any) => {
    return (
      <>
        <CommandCell
          {...columnProps}
          edit={props.deleteExclusion}
          icon={faTrash}
        />
      </>
    );
  };

  const gridData = props.data.map((exclusion) => {
    exclusion.date = new Date(exclusion.date);
    return exclusion;
  });
  const result = process(gridData, dataState);

  return (
    <>
      <Grid
        {...dataState}
        className={`order-exclusion-grid ${props.className}`}
        data={result}
        selectedField="selected"
        pageable
        resizable
        pageSize={26}
        onDataStateChange={dataStateChange}
        sortable
      >
        <GridColumn
          {...columnProps('date')}
          title={locale.orderExclusions._date}
          format={'{0:' + locale.general._fullDateFormat + '}'}
          width={95}
          sortable
          filter="date"
        />
        <GridColumn
          {...columnProps('name')}
          title={locale.orderExclusions._name}
          sortable
          filter="text"
        />
        <GridColumn width={'40px'} cell={UpdateExclusionCell} />
        <GridColumn width={'40px'} cell={DeleteExclusionCell} />
      </Grid>
    </>
  );
}
